<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <!-- Avatar Row -->
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">

          <div class="vx-row">
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.user.dataForm.prefix')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.user.dataForm.prefix') }}*</label>
                <v-select v-model="form.prefix" :clearable="false"  :options="prefixOptions" :name="$t('sections.user.dataForm.prefix')" :reduce="res => res.value"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.user.dataForm.name')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.user.dataForm.name") }}*</label>
                <vs-input type="text" v-model="form.name" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.user.dataForm.surname')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.user.dataForm.surname')}}*</label>
                <vs-input type="text" v-model="form.surname" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.user.dataForm.username')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.user.dataForm.username') }}*</label>
                <vs-input type="text" v-model="form.username" class="w-full" disabled="disabled" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.user.dataForm.email')" rules="required|email" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.user.dataForm.email') }}*</label>
                <vs-input type="email" v-model="form.email" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.user.dataForm.role')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.user.dataForm.role') }}*</label>
                <v-select v-model="form.role" :clearable="false" :options="rolesOptions" :name="$t('sections.user.dataForm.role')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider name="รหัสพนักงานขาย" rules="" v-slot="{ errors }">
                <label class="vs-input--label">รหัสพนักงานขาย</label>
                <vs-input type="email" v-model="form.saleCode" class="w-full" :disabled="saleCodeDisabled"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.user.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.user.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'

const {mapActions: mapUserActions, mapState: mapUserFields } = createNamespacedHelpers('User')
const {mapActions: mapMasterActions } = createNamespacedHelpers('Master')
const {mapActions: mapSystemActions } = createNamespacedHelpers('System')

export default {
  components: {
    vSelect,
    ValidationProvider
  },
  data () {
    return {
      form:{
        prefix: '',
        name: '',
        surname: '',
        username: '',
        email: '',
        saleCode: '',
        role: ''
      },
      data:{
        avatar: require('@/assets/images/portrait/small/avatar-s-0.jpg')
      }
    }
  },
  async created() {
    const vm = this;
    const { getPrefixOptions } = vm
    await getPrefixOptions()
    await this.getRoles()
    await this.getUser({form: {id: this.$route.params.id}})
    this.pms ('UserAdmin', 'edit', 'r')
    this.reset()
  },
  computed: {
    ...mapUserFields(['status', 'user']),
    ...mapGetters({
      prefixOptions :'Master/prefixOptions',
      rolesOptions :'System/rolesOptions'
    }),
    saleCodeDisabled(){
      return false;
    },
  },
  methods: {
    ...mapUserActions(['getUser', 'updateUser']),
    ...mapMasterActions(['getPrefixOptions']),
    ...mapSystemActions(['getRoles']),
    async submit () {
      const vm = this
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        await this.updateUser({
          id: this.$route.params.id,
          form: {
            prefix: {id: vm.form.prefix},
            name: vm.form.name,
            surname: vm.form.surname,
            email: vm.form.email,
            role: {id: vm.form.role}
          },
          vm,
          redirect: "/user/admin"
        })
      })
    },
    reset () {
    const vm = this
      vm.form = {
        prefix: (vm.user.prefix ? vm.user.prefix.id : ''),
        name: vm.user.name,
        surname: vm.user.surname,
        username: vm.user.username,
        email: vm.user.email,
        saleCode: vm.user.saleCode,
        // status: vm.user.status,
        role: (vm.user.role ? vm.user.role.id : '')
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
